// @flow
import { COUNTRY_EVENTS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_COUNTRY_EVENTS } from 'Utils/request/requestDictionary';

export const countryEventsResolver = {
  name: COUNTRY_EVENTS,
  resolve(appContext: AppContext, props: { countryId: string, isForFamily: boolean } = {}) {
    const { countryId, isForFamily } = props;
    const countryArgs = `countryId:"${countryId}" isForFamily:${isForFamily.toString()}`;

    const query = `query {
      config {
        common { close }
      }
      countryEvents(${countryArgs}) {
        title
        description
        media {
          mediaUrl
          mediaAlt
        }
        startDate
        endDate
        associatedProducts {
          name
          href
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_COUNTRY_EVENTS,
      strictErrors: false,
    });
  },
};
